/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Component to update an permission
 * @export
 * @interface UpdateUsersPermissionsRequest
 */
export interface UpdateUsersPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUsersPermissionsRequest
     */
    permissionName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUsersPermissionsRequest
     */
    active?: boolean;
    /**
     * the unique identifier of the institute
     * @type {string}
     * @memberof UpdateUsersPermissionsRequest
     */
    instituteId?: string;
}

/**
 * Check if a given object implements the UpdateUsersPermissionsRequest interface.
 */
export function instanceOfUpdateUsersPermissionsRequest(value: object): value is UpdateUsersPermissionsRequest {
    return true;
}

export function UpdateUsersPermissionsRequestFromJSON(json: any): UpdateUsersPermissionsRequest {
    return UpdateUsersPermissionsRequestFromJSONTyped(json, false);
}

export function UpdateUsersPermissionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUsersPermissionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionName': json['permissionName'] == null ? undefined : json['permissionName'],
        'active': json['active'] == null ? undefined : json['active'],
        'instituteId': json['instituteId'] == null ? undefined : json['instituteId'],
    };
}

export function UpdateUsersPermissionsRequestToJSON(json: any): UpdateUsersPermissionsRequest {
    return UpdateUsersPermissionsRequestToJSONTyped(json, false);
}

export function UpdateUsersPermissionsRequestToJSONTyped(value?: UpdateUsersPermissionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionName': value['permissionName'],
        'active': value['active'],
        'instituteId': value['instituteId'],
    };
}

